(function () {
    'use strict';

    angular.module("imApp").factory("projectProcessesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 906,
                    parameters: parms || {}
                });
            },
            listPosts: function (parms) {
                return $ihttp.post({
                    method: 907,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
